/* Wav Monopoly — audio preview player.
   Binds direct listeners per <audio> (media events don't bubble, so delegation is unreliable).
   Only one clip plays at a time; click the track to seek. */
(function () {
  if (window.__wmAudioInit) return;
  window.__wmAudioInit = true;

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60);
    var s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function initPlayer(wrap) {
    if (wrap.__wmInit) return;
    wrap.__wmInit = true;

    var audio = wrap.querySelector('audio');
    if (!audio) return;
    var btn = wrap.querySelector('.wm-audio__btn');
    var track = wrap.querySelector('.wm-audio__track');
    var fill = wrap.querySelector('.wm-audio__fill');
    var time = wrap.querySelector('.wm-audio__time');
    var iconPlay = wrap.querySelector('.wm-audio__icon-play');
    var iconPause = wrap.querySelector('.wm-audio__icon-pause');

    function setPlaying(p) {
      wrap.classList.toggle('is-playing', p);
      if (iconPlay) iconPlay.style.display = p ? 'none' : '';
      if (iconPause) iconPause.style.display = p ? '' : 'none';
    }

    if (btn) {
      btn.addEventListener('click', function () {
        if (audio.paused) {
          document.querySelectorAll('[data-wm-audio] audio').forEach(function (a) {
            if (a !== audio) a.pause();
          });
          var p = audio.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          audio.pause();
        }
      });
    }

    if (track) {
      track.addEventListener('click', function (e) {
        if (!isFinite(audio.duration) || !audio.duration) return;
        var r = track.getBoundingClientRect();
        audio.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * audio.duration;
      });
    }

    audio.addEventListener('play', function () { setPlaying(true); });
    audio.addEventListener('pause', function () { setPlaying(false); });
    audio.addEventListener('timeupdate', function () {
      var d = audio.duration;
      if (fill) fill.style.width = (isFinite(d) && d > 0 ? (audio.currentTime / d) * 100 : 0) + '%';
      if (time) time.textContent = fmt(audio.currentTime);
    });
    audio.addEventListener('ended', function () {
      if (fill) fill.style.width = '0%';
      if (time) time.textContent = '0:00';
      setPlaying(false);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-wm-audio]').forEach(initPlayer);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  // Re-init when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.wmInitAudio = initAll;
})();
